import { Box, Button, Typography } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import React from 'react';
import useStyles from '../styles';

const AccountInfoPanel = ({ vehicle, isAdmin, canWarehouseTransfer, onBatchTransfer }) => {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.kvGroup}>
        <Typography className={classes.kvGroupTitle}>Đại lý</Typography>
        {[
          ['Đại lý', vehicle?.agency_name, true],
          ['Số điện thoại', vehicle?.agency_phone],
        ].map(([label, value, wrap]) => (
          <Box
            key={label}
            className={classes.kvRow}
            style={wrap ? { alignItems: 'flex-start' } : undefined}
          >
            <span className={classes.kvLabel}>{label}</span>
            <span
              className={wrap ? classes.kvValueWrap : classes.kvValue}
              title={value || ''}
            >
              {value || '--'}
            </span>
          </Box>
        ))}
        {canWarehouseTransfer && vehicle.device_id && (
          <Button
            fullWidth
            className={`btn-main btn-plain ${classes.mapButton} ${classes.kvGroupButton}`}
            color="primary"
            variant="contained"
            startIcon={<SwapHorizIcon />}
            onClick={() => onBatchTransfer('warehouse')}
          >
            Chuyển kho
          </Button>
        )}
      </Box>

      <Box className={classes.kvGroup}>
        <Typography className={classes.kvGroupTitle}>Khách hàng</Typography>
        {[
          ['Khách hàng', vehicle.end_user.full_name],
          ['Tên đăng nhập', vehicle.end_user.username],
          ['Số điện thoại', vehicle.end_user.phone],
        ].map(([label, value]) => (
          <Box key={label} className={classes.kvRow}>
            <span className={classes.kvLabel}>{label}</span>
            <span className={classes.kvValue} title={value || ''}>{value || '--'}</span>
          </Box>
        ))}
        {isAdmin && vehicle.device_id && (
          <Button
            fullWidth
            className={`btn-main btn-plain ${classes.mapButton} ${classes.kvGroupButton}`}
            color="primary"
            variant="contained"
            startIcon={<PersonIcon />}
            onClick={() => onBatchTransfer('end_user')}
          >
            Đổi khách hàng
          </Button>
        )}
      </Box>
    </>
  );
};

export default AccountInfoPanel;
